import React, {Component} from 'react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'

export class Checkbox extends Component {
    render() {
        const props = this.props,
            onChange = props.onChange || (() => {
            });

        let className = 'checkbox-container';
        if (props.className) {
            className += ' ' + props.className;
        }
        return (
            <div
                className={className}
                onClick={() => {
                    onChange(props.id)
                }}
            >
                <div
                    className={'checkbox' + (props.value ? ' active' : '')}
                    style={
                        !props.styleObject
                            ? null
                            : props.value
                            ? props.styleObject.active
                            : props.styleObject.notActive
                    }
                >
                    <FontAwesomeIcon icon="check"/>
                </div>
                <div
                    className='checkbox-label'
                    style={props.styleObject && props.styleObject.label ? props.styleObject.label : null}
                >
                    {props.caption}
                </div>
            </div>
        );
    }
}